export default "__VITE_ASSET__QIhzqsts__"